import { useState } from "react";

import {
  makeGetApiCall,
  makePostApiCall,
  makePutApiCall,
} from "../../../shared/makeApiCall";
import { BannerNotificationType } from "../../../components/SimpleNotification";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import { updateObjectInArray } from "../../../shared/utility";
import LocationDetailsForm from "../../../components/forms/setup/locations/LocationDetailsForm";
import ModelErrorComponent from "../../../components/modals/ModelErrorComponent";

export function WarehouseDetailsViewModel(logout, warehouseId) {
  const [loading, setLoading] = useState(false);
  const [warehouse, setWarehouse] = useState({
    data: [],
  });
  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [locations, setLocations] = useState({
    data: [],
  });

  const getWarehouseDetails = async function () {
    setLoading(true);

    let callResult = await makeGetApiCall(`warehouses/${warehouseId}`);
    setLoading(false);
    if (callResult.success) {
      setWarehouse(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const getWarehouseLocations = async function () {
    setLoading(true);

    let callResult = await makeGetApiCall(`warehouseLocations/${warehouseId}`);
    setLoading(false);
    if (callResult.success) {
      setLocations(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  //   const updateWarehouse = async function (values, index) {
  //     let callResult = await makePutApiCall(`warehouses/${values.id}`, values);

  //     if (callResult.success) {
  //       setShowSimpleNotification({
  //         show: true,
  //         title: "Warehouse updated",
  //         type: BannerNotificationType.Success,
  //       });
  //       setSlideOver({
  //         childComponent: null,
  //         open: false,
  //       });

  //       const currentItems = [...warehouses.data];
  //       var payload = {
  //         index: index,
  //         item: callResult.data.item,
  //       };
  //       const newItems = updateObjectInArray(currentItems, payload);
  //       setWarehouses({ ...warehouses, data: newItems });
  //     } else {
  //       if (callResult.errorStatus === 401) {
  //         logout();
  //       }
  //     }
  //   };

  const createLocation = async function (values) {
    const payload = { ...values, warehouseId: warehouseId };
    let callResult = await makePostApiCall(
      "warehouseLocations/create",
      payload
    );

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Location added",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getWarehouseLocations();
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateLocation = async function (values, index) {
    let callResult = await makePutApiCall(
      `warehouseLocations/${values.id}`,
      values
    );

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Location updated",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });

      const currentItems = [...locations.data];
      var payload = {
        index: index,
        item: callResult.data.item,
      };
      const newItems = updateObjectInArray(currentItems, payload);
      setLocations({ ...locations, data: newItems });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddLocationSlideOver = (isEdit, location, index) => {
    setSlideOver({
      childComponent: (
        <LocationDetailsForm
          location={location}
          isEdit={isEdit}
          setOpen={setSlideOver}
          actionCall={(payload) =>
            isEdit ? updateLocation(payload, index) : createLocation(payload)
          }
          title={isEdit ? `Update ${location.name}` : "Add new location"}
        />
      ),
      open: true,
    });
  };

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const deleteLocation = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteWarehouseLocation/${id}`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = locations.data.filter((item) => item.id !== id);
      setLocations({ ...locations, data: newItems });

      setShowSimpleNotification({
        show: true,
        title: callResult.data.message,
        type: BannerNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const askDeleteLocation = function (warehouse, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteLocation(warehouse.id, index)}
          message={`Are you sure you want to delete  ${warehouse.name}?`}
          setOpen={setEmptyModelOpen}
          hideReason={true}
        />
      ),
      open: true,
    });
  };

  return {
    getWarehouseDetails,
    loading,
    warehouse,
    setSlideOver,
    slideOver,
    locations,
    setShowSimpleNotification,
    showSimpleNotification,
    setEmptyModelOpen,
    emptyModal,
    openAddLocationSlideOver,
    getWarehouseLocations,
    askDeleteLocation,
  };
}
